import { render, staticRenderFns } from "./DVipEmailEditor.vue?vue&type=template&id=47003ff4&"
import script from "./DVipEmailEditor.vue?vue&type=script&lang=js&"
export * from "./DVipEmailEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports